import { Pipe, PipeTransform } from '@angular/core';
import { translateActionLogStatus } from '../mappers/enum-translation-mapper';

@Pipe({
  name: 'translateActionLogStatusEnum',
})
export class TranslateActionLogStatusEnumPipe implements PipeTransform {
  transform(value: any): any {
    return translateActionLogStatus(value);
  }
}
